import React from 'react';
import { connect } from 'react-redux';
import signupContext from 'src/constants/signupContext';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import i18n from 'src/utils/translate';
import { getLocalStorageItem, setLocalStorageItem } from 'src/utils/localStorage';
import Animate from 'src/components/animate';

const HIDE_FLOATING_SIGNUP_BOX = '__hu_show_floating_box__'; // this should really be *hide*_floating_box

class FloatingBox extends React.Component {

  hide = () => {
    setLocalStorageItem(HIDE_FLOATING_SIGNUP_BOX, true);
    // force update to check updated local storage value
    this.forceUpdate();
  };

  handleDismiss = () => {
    this.hide();
  }

  onSubmitEmail = (e, refName) => {
    e.preventDefault();
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickMetadata: { element: 'join', section: 'sticky-footer' },
      clickType: 'sign-up',
    });
    this.props.showSignupModal({ section: signupContext.section.FLOATING_BOX }, null, false, this[refName].value);
  }

  render() {
    if (getLocalStorageItem(HIDE_FLOATING_SIGNUP_BOX)) {
      return null;
    }

    return (
      <Animate classNames="TRANSITION-simpleFade" show={this.props.show}>
        <div className="floating-box">
          <div className="floating-box-sign-up">
            <a className="floating-box-sign-up__dismiss icon-close" onClick={this.handleDismiss} />
            <div className="floating-box-sign-up__title">
              <span className="hidden-xs">
                {i18n.t('Connect with others who understand.')}
              </span>
              <span className="visible-xs">
                {i18n.t('Join the #1 peer-support network for health. Ask questions. Get answers.')}
              </span>
            </div>
            <div className="floating-box-sign-up__content">
              <span className="hidden-xs">
                {i18n.t('Join the #1 peer-support network for health. Ask questions. Get answers.')}
              </span>
              <form className="floating-box-sign-up__content__form" onSubmit={e => this.onSubmitEmail(e, 'emailRef')}>
                <input
                  className="form-control floating-box-sign-up__form-input"
                  placeholder={i18n.t('email@address.com')}
                  ref={node => (this.emailRef = node)}
                  type="text"
                />
                <button className="floating-box-sign-up__button btn btn-primary btn-lg" type="submit">
                  <span className="hidden-xs">{i18n.t('Join HealthUnlocked')}</span>
                  <span className="visible-xs">{i18n.t('Join')}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </Animate>
    );
  }
}

export default connect(null, { showSignupModal })(FloatingBox);
